module.exports = __webpack_public_path__ + "img/ginkgo-text.a208ee67.png";